import { render, staticRenderFns } from "./ProjectTerminated.vue?vue&type=template&id=0ebe8ea3&"
import script from "./ProjectTerminated.vue?vue&type=script&lang=js&"
export * from "./ProjectTerminated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports